<template>
  <div class="page">
    <PageHeader>
      Типы
    </PageHeader>
    <div class="content">
      <el-card shadow="always" :body-style="{ padding: '20px' }" v-loading="loading">
        <div v-if="sourceTypes.docs">
          <el-table :data="sourceTypes.docs" @sort-change="handleSortChange"
            :default-sort="{ prop: '_id', order: 'descending' }" :row-class-name="tableRowClassName" border stripe>
            <el-table-column sortable="custom" prop="_id" label="ID" width="90">
              <template slot-scope="scope">
                <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
                {{ scope.row._id.slice(-6) }}
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="title" label="Заголовок">
            </el-table-column>
            <el-table-column sortable="custom" prop="sourceType" label="Название">
            </el-table-column>
            <el-table-column v-if="session.type <= -1" fixed="right" label="Действия" width="150">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="handleEditRow(scope.row)"
                ></el-button>
                <el-tooltip placement="top">
                  <div slot="content">Удалить</div>
                  <el-button size="small" icon="el-icon-delete" @click="handleDeleteItem(scope.row._id)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="sourceTypes.page"
            :page-size="sourceTypes.limit"
            layout="sizes, prev, pager, next, jumper"
            :total="sourceTypes.totalDocs"
          ></el-pagination>
          <el-drawer
            :title="`Редактируем строку`"
            :before-close="handleCloseEditPopup"
            :visible.sync="showEditRowPopup"
            direction="ltr"
            ref="editrowpopup"
          >
          <el-card shadow="always" :body-style="{ padding: '20px' }">
          <el-form :model="rowEdit">
            <el-form-item label="Заголовок">
                <el-input v-model="rowEdit.sourceType"></el-input>
            </el-form-item>
            <el-form-item label="Название">
                <el-input v-model="rowEdit.title"></el-input>
            </el-form-item>
            <div class="demo-drawer__footer">
          <el-button @click="cancelRowEdit">Отмена</el-button>
          <el-button
            type="primary"
            @click="handleUpdateRow"
            :loading="loadingEditRow"
            >{{ loadingEditRow ? "Сохраняю ..." : "Сохранить" }}</el-button
          >
        </div></el-form>
        </el-card>
          </el-drawer>
              </div>
        <el-collapse >
          <el-collapse-item name="1" >
            <template slot="title">
              <i class="header-icon el-icon-plus"></i>
              Добавить
            </template>
            <el-form :model="newSourceType" ref="form" label-width="80px" :inline="false" size="normal">
              <el-form-item label="Заголовок">
                <el-input v-model="newSourceType.sourceTypeTitle"></el-input>
              </el-form-item>
              <el-form-item label="Название">
                <el-input v-model="newSourceType.sourceTypeName"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addItem">Добавить</el-button>
                <el-button @click="resetForm">Очистить</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  </div>
</template>
<script>
import {
  updateSourceTypeRow,
  getSourceTypes,
  addSourceType,
  deleteSourceType,
} from "@/api";
import { mapState, mapActions, mapGetters } from "vuex";
import PageHeader from "../../ui/PageHeader.vue";
export default {
  components: { PageHeader },
  name: "SourceTypesPage",
  data: () => ({
    loading: true,
    newSourceType: {
      sourceTypeName: "",
      sourceTypeTitle: "",
    },
    sourceTypes: [],
    rowEdit: {},
    loadingEditRow: false,
    showEditRowPopup: false,
    page: 1,
    limit: 10,
    sort: "-_id"
  }),
  computed: {
    ...mapState("auth", ["session"])
  },
  methods: {
    async handleUpdateRow(){
      console.log('this.sad = ',this.rowEdit)
        this.loadingEditRow = true;
        const { data } = await updateSourceTypeRow(this.rowEdit);
        if(data){
          this.loadingEditRow = false;
        }
        await this.getSourceTypes();
        this.showEditRowPopup = false;
    },
    cancelRowEdit() {
      this.rowEdit = {};
      this.loadingEditRow = false;
      this.showEditRowPopup = false;
    },
    handleEditRow(row) {
      console.log(row)
      this.rowEdit = { ...row };
      this.showEditRowPopup = true;
    },
    handleCloseEditPopup(done) {
      this.showEditRowPopup = false;
    },
    async getSourceTypes() {
      try {
        this.loading = true;
        const { data } = await getSourceTypes({
          page: this.page,
          limit: this.limit,
          sort: this.sort
        });
        if (data.status) this.sourceTypes = data.result;
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleDeleteItem(id) {
      let message = "Вы точно хотите удалить тип?";
      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await deleteSourceType(id);
        await this.getSourceTypes();
        this.$message({
          type: "success",
          message: `Тип успешно удален успешно удален`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    async handleSortChange(sortData) {
      this.sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
            ? `-${sortData.prop}`
            : "";
      await this.getSourceTypes();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getSourceTypes();
    },
    resetForm() {
      this.newSourceType = {
        sourceTypeName: "",
        sourceTypeTitle: "",
      };
    },
    async addItem() {
      try {
        const data = {
          ...this.newSourceType
        };
        console.log(data)
        const resp = await addSourceType(data);
        await this.getSourceTypes();
        this.resetForm();
        return this.$notify.success({
          title: "Успех",
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    }
  },
  async mounted() {
    await this.getSourceTypes();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/SourceTypes/index.vue